import React from "react";
import Layout from "../../components/layout/Layout";
import { PresentionChart } from "iconsax-react";
import { MdFileDownload } from "react-icons/md";

function Report() {
  return (
    <Layout
      pageName="Analytics and Report "
      icon={<PresentionChart size="40" color="#071839" />}
    >
      <section className="mt-4 card bg-white rounded-md p-4">
        <div className="flex items-center justify-between">
          <h4>Reports</h4>
          <button className="btn btn-sm btn-outline">
            <MdFileDownload />{" "}
          </button>
        </div>

        <table className="table mt-6">
          <thead className="bg-[#F5F5F5]">
            <tr>
              <th></th>
              <th>Name</th>
              <th>Description</th>
              <th>Metrics Included</th>
              <th>Date Created</th>
              <th>Last Updated</th>
              <th></th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody className="font-xs font-normal">
            <tr className="font-xs font-normal">
              <th> 1</th>
              <th className="font-xs font-normal">Weekly Leaderboard</th>
              <th className="font-xs font-normal">
                Displays the top scores and users of the week.
              </th>
              <th className="text-xs font-normal text-center">
                Player ID, Scores
              </th>
              <th className="text-xs font-normal text-center">12/03/2024</th>
              <th className="text-xs font-normal text-center">12/03/2024</th>
            </tr>
          </tbody>
        </table>
      </section>
    </Layout>
  );
}

export default Report;
